module.exports = __webpack_public_path__ + "img/18-plus-serbia.e385a5f2.png";